import { defineMessages } from 'react-intl';

export default defineMessages({
  loginRequiredError: {
    id: 'LOGIN_ACCOUNT_RECOVERY_LOGIN_REQUIRED',
    defaultMessage:
      'We could not find a reset request for your account, please create a new one.',
  },
  genericError: {
    id: 'LOGIN_ACCOUNT_RECOVERY_GENERIC_ERROR',
    defaultMessage:
      'Da ist leider etwas schiefgelaufen. Probieren Sie es bitte später noch einmal.',
  },
  emailLinkInvalid: {
    id: 'LOGIN_ACCOUNT_RECOVERY_LINK_INVALID',
    defaultMessage:
      'Unfortunately the link to confirm your account recovery is not valid anymore.',
  },
  activeCredentialNotFoundError: {
    id: 'LOGIN_ACCOUNT_RECOVERY_ACTIVE_CREDENTIAL_NOT_FOUND_ERROR',
    defaultMessage: 'Diesen Zugang kennen wir leider nicht.',
  },
  activeCredentialNotProvidedError: {
    id: 'LOGIN_ACCOUNT_RECOVERY_ACTIVE_CREDENTIAL_NOT_PROVIDED_ERROR',
    defaultMessage:
      'Bitte geben Sie Ihre bei XING aktivierte E-Mail-Adresse oder Handynummer an.',
  },
  imageNotFoundProvidedError: {
    id: 'LOGIN_ACCOUNT_RECOVERY_IMAGE_NOT_PROVIDED_ERROR',
    defaultMessage: 'Bitte laden Sie ein Foto zur Identitätsprüfung hoch.',
  },
  invalidSession: {
    id: 'LOGIN_ACCOUNT_RECOVERY_INVALID_SESSION',
    defaultMessage:
      'Leider ist ein Fehler aufgetreten. Bitte starten Sie den Wiederherstellungsprozess noch einmal.',
  },
  newEmailNotProvidedError: {
    id: 'LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_NOT_PROVIDED_ERROR',
    defaultMessage:
      'Bitte geben Sie die E-Mail Adresse an, mit welcher Sie sich zukünftig bei XING anmelden wollen.',
  },
  newEmailUnavailableError: {
    id: 'LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_UNAVAILABLE_ERROR',
    defaultMessage:
      'Diese Adresse existiert bereits. Versuchen Sie sich mit dieser Adresse {link} oder Ihr Passwort zurückzusetzen.',
  },
  newEmailUnavailableErrorLink: {
    id: 'LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_UNAVAILABLE_ERROR_LINK',
    defaultMessage: 'anzumelden',
  },
  requestLimitReached: {
    id: 'LOGIN_ACCOUNT_RECOVERY_REQUEST_LIMIT_REACHED',
    defaultMessage:
      'Sie haben leider zu häufig versucht, Ihren Account wiederherzustellen. Bitte versuchen Sie es in zwölf Stunden noch einmal.',
  },
  resetRequestAlreadyOpen: {
    id: 'LOGIN_ACCOUNT_RECOVERY_RESET_REQUEST_ALREADY_OPEN_ERROR',
    defaultMessage:
      'Bitte bestätigen Sie Ihre vorherige Anfrage zur Wiederherstellung Ihres Accounts.',
  },
  wrongConfirmationCode: {
    id: 'LOGIN_ACCOUNT_RECOVERY_WRONG_CONFIRMATION_CODE',
    defaultMessage:
      'Dieser Code stimmt leider nicht. Haben Sie sich vielleicht vertippt?',
  },
  fileUploadMissing: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_MISSING_ERROR',
    defaultMessage: 'Bitte wählen Sie ein Bild aus um fortzufahren.',
  },
  fileUploadSizeExceeded: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_SIZE_EXCEEDED_ERROR',
    defaultMessage: 'Die größe des Bildes darf nicht 2MB überschreiten.',
  },
  fileUploadTypeNotAccepted: {
    id: 'LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_TYPE_NOT_ACCEPTED_ERROR',
    defaultMessage: 'Bitte wählen Sie als Bild ein JPG oder PNG.',
  },
  confirmCodeInvalid: {
    id: 'LOGIN_ACCOUNT_RECOVERY_CODE_INVALID',
    defaultMessage:
      'Zu Ihrer Sicherheit funktioniert dieser Code nur kurze Zeit – und ist jetzt schon abgelaufen. Bitte starten Sie den Prozess einfach erneut.',
  },
});
